module.exports = __webpack_public_path__ + "static/media/googleplayicon.36d178ce.png";